// src/components/Header.js
import React from "react";

import { Link } from "react-router-dom";

const Header = (selection) => {
  return (
    <>
      {/* <!-- Main Header--> */}
      <header className="main-header header-style-two">
        {/* <!-- Header Top --> */}
        <div className="header-top">
          <div className="inner-container">
            <div className="top-left">
              {/* <!-- Info List --> */}
              <ul className="list-style-one">
                <li>
                  <i className="fa fa-envelope"></i>
                  <a href="mailto:enquiry@startechdistribution.com">
                    enquiry@startechdistribution.com
                  </a>
                </li>
                <li>
                  <i className="fa fa-map-marker-alt"></i> No.31-2, Petaling
                  Utama Avenue, Jalan PJS 1/50, Taman Petaling Utama, 46150
                  Petaling Jaya, Selangor, Malaysia.
                </li>
              </ul>
            </div>

            <div className="top-right">
              <ul className="useful-links">
                <li>
                  <Link to={"/career"}>
                    <u>Career</u>
                  </Link>
                </li>
                <li>
                  <Link to={"/contact"}>
                    <u>Contact Us</u>
                  </Link>
                </li>
                <li>
                  <Link to={"/cart"}>
                    <u>Enquiry List</u>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="outer-box">
            <ul className="social-icon-one">
              <li>
                <a
                  href="https://www.linkedin.com/company/startechdistribution"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="fab fa-linkedin"></span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/startechdistributionsb/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="fab fa-facebook-square"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* <!-- Header Top --> */}

        {/* <!-- Header Lower --> */}
        <div className="header-lower">
          {/* <!-- Main box --> */}
          <div className="main-box">
            <div className="logo-box">
              <div className="logo">
                <Link to={"/"}>
                  <img
                    src="/images/startech_logo.png"
                    alt="Star Tech Logo"
                    title=""
                    style={{ width: "160px" }}
                  />
                </Link>
              </div>
            </div>

            {/* <!--Nav Box--> */}
            <div className="nav-outer">
              <nav className="nav main-menu">
                <ul className="navigation d-flex align-items-center">
                  <li
                    className={`${
                      selection.selection == "about" ? "current" : ""
                    }`}
                  >
                    <Link to={"/about"}>About Us</Link>
                  </li>
                  <li
                    className={`${
                      selection.selection == "news" ? "current" : ""
                    }`}
                  >
                    <Link to={"/news"}>News & Events</Link>
                  </li>
                  <li
                    className={`${
                      selection.selection == "portfolio" ? "current" : ""
                    }`}
                  >
                    <Link to={"/portfolio"}>Portfolio</Link>
                  </li>
                  <li
                    className={`${
                      selection.selection == "products" ? "current" : ""
                    } ${
                      selection.selection == "brands" ? "current" : ""
                    } dropdown`}
                  >
                    <Link to={"/shopping"}>
                      Products
                      <span
                        style={{
                          marginLeft: "6px",
                          padding: "2px 6px",
                          fontSize: "12px",
                          fontWeight: 600,
                          borderRadius: "12px",
                          backgroundColor: "#ff6b6b",
                          color: "#fff",
                        }}
                      >
                        New
                      </span>
                    </Link>
                    <ul>
                      <li>
                        <Link to={"/brands"}>All Brands</Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=1">
                          Analogue & SIP Phones
                        </Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=2">
                          Communication Headsets
                        </Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=3">Industrial Phones</Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=4">
                          GSM & Wi-Fi Phones
                        </Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=5">
                          Intercoms, Door Phones, Smart Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=6">
                          Meeting Room Solution
                        </Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=7">
                          Wireless Screen Sharing
                        </Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=8">ESBC Gateways</Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=9">IP PBX Systems</Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=10">VoIP Gateway</Link>
                      </li>
                      <li>
                        <Link to="/shopping?category=11">Data Networking</Link>
                      </li>
                      {/* <li className='dropdown'>
                        <a href='#'>Terminal Products</a>
                        <ul>
                          <li>
                            <a className='fw-bold' href='/brands'>
                              Devices Catalog
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Explore our complete portfolio of devices for
                              individuals and conference rooms.
                            </div>
                          </li>
                        </ul>
                      </li> */}
                    </ul>
                  </li>
                  <li
                    className={`${
                      selection.selection == "solutions" ? "current" : ""
                    } dropdown`}
                  >
                    <Link>Solutions</Link>
                    <ul>
                      {/* Commented out old solutions
                      <li>
                        <Link to={'/solutions'}>Solutions</Link>
                      </li>
                      <li className='dropdown'>
                        <a href='#'>Unified Communication (UC)</a>
                        <ul>
                          <li>
                            <a className='fw-bold' href='#'>
                              Contact Center
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Integrated various communication tools for
                              seamless interaction.
                            </div>
                          </li>
                          <li>
                            <a
                              className='fw-bold'
                              href='https://telrranet.com/'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Telrranet On-Prem
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Full featured contact center solution.
                            </div>
                          </li>
                          <li>
                            <a
                              className='fw-bold'
                              href='https://telrranet.com/'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Telrranet Cloud
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Cloud Contact Center: Secure, Dedicated, and
                              Managed.
                            </div>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Enterprise Session Border Controller
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Secures and manages IP voice and video
                              communications.
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className='dropdown'>
                        <a href='#'>Meeting Room Solution Products</a>
                        <ul>
                          <li>
                            <a className='fw-bold' href='#'>
                              AudioCodes Room Solutions
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              An innovative device portfolio for today's busy
                              hybrid workplace.
                            </div>
                          </li>
                          <li>
                            <a
                              className='fw-bold'
                              href='https://www.audiocodes.com/solutions-products/solutions/meeting-room-solutions/large-meeting-room-solutions'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Large Meeting Room Solutions
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Get the best from your people with effortless team
                              meetings and group collaboration.
                            </div>
                          </li>
                          <li>
                            <a
                              className='fw-bold'
                              href='https://www.audiocodes.com/solutions-products/solutions/meeting-room-solutions/medium-meeting-room-solutions'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Medium Meeting Room Solutions
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Enabling effortless collaboration between
                              medium-sized groups and remote users.
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className='dropdown'>
                        <a href='#'>Business Need</a>
                        <ul>
                          <li>
                            <a className='fw-bold' href='#'>
                              Innovation Without Disruption
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Progress at your own speed with Startech's hybrid
                              cloud solutions.
                            </div>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Customer Experience
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Provide seamless experiences for both customers
                              and employees at every interaction.
                            </div>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Remote Contact Center
                            </a>
                            <div
                              style={{ padding: '0px 25px', fontSize: '14px' }}
                            >
                              Ensure your contact center operates efficiently,
                              regardless of your employees' locations.
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className='dropdown'>
                        <a href='#'>Industry</a>
                        <ul>
                          <li>
                            <a className='fw-bold' href='#'>
                              Telecommunication
                            </a>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Hospitality, Office and Business
                            </a>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Industrial Emergency Phone
                            </a>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Oil and Gas
                            </a>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Hotel and Residential
                            </a>
                          </li>
                          <li>
                            <a className='fw-bold' href='#'>
                              Education and Financial Institution
                            </a>
                          </li>
                        </ul>
                      </li>
                      */}
                      {/* New Smart Solutions */}
                      <li>
                        <a href="#">Smart Office</a>
                      </li>
                      <li>
                        <a href="#">Smart Hotel</a>
                      </li>
                      <li>
                        <a href="#">Smart Class Room</a>
                      </li>
                      <li>
                        <a href="#">Smart Condo</a>
                      </li>
                      <li>
                        <a href="#">Smart Home</a>
                      </li>
                      <li>
                        <a href="#">Smart Meeting Room</a>
                      </li>
                      <li>
                        <a href="#">Smart UC - New Lync</a>
                      </li>
                      <li>
                        <a href="#">Smart Telco- Aaranet</a>
                      </li>
                      <li>
                        <a href="#">Smart Hospitality</a>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`${
                      selection.selection == "solutions" ? "" : ""
                    } dropdown`}
                  >
                    <Link>
                      System & <br /> Applications
                    </Link>
                    <ul>
                      <li className="dropdown">
                        <a href="#">AudioCodes</a>
                        <ul>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://en.newrocktech.com/product/info_itemid_386.html"
                              target="_blank"
                              rel="noreferrer"
                            >
                              AudioCodes Smarttap
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Advanced call recording and analytics solution
                              designed for capturing voice and video
                              communications in real-time.
                            </div>
                          </li>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://www.nxcloud.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Voca Conversational Interaction Center
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              AI solution that powers intelligent and automated
                              customer interactions using voice and chat.
                            </div>
                          </li>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://telrranet.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Meeting Insights
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Post-meeting analytics and reporting solution
                              designed to optimize the meeting experience.
                            </div>
                          </li>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://en.newrocktech.com/product/info_itemid_387.html"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Enterprise Session Border Controller
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Provides robust security, scalability, and
                              optimization for voice and video traffic across
                              enterprise networks.
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <a href="#">Communication & Collaboration </a>
                        <ul>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://en.newrocktech.com/product/info_itemid_386.html"
                              target="_blank"
                              rel="noreferrer"
                            >
                              NewLync
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Digital collaboration platform offering integrated
                              communication and collaboration tools for
                              enterprises.
                            </div>
                          </li>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://www.nxcloud.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              NXCLOUD
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Communication solutions and collaboration that
                              simplify global customer engagement for businesses
                              of all sizes.
                            </div>
                          </li>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://telrranet.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Telrranet App
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Call, meet, message, and more-all in one app.
                            </div>
                          </li>
                          <li>
                            <a
                              className="fw-bold"
                              href="https://en.newrocktech.com/product/info_itemid_387.html"
                              target="_blank"
                              rel="noreferrer"
                            >
                              OMX
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Unified Communication platform, high-capacity
                              cloud PBX.
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`${
                      selection.selection == "technical" ? "current" : ""
                    } dropdown`}
                  >
                    <Link to={"#"}>Services & Supports</Link>
                    <ul>
                      <li className="dropdown">
                        <a href="#">Services</a>
                        <ul>
                          <li>
                            <a className="fw-bold" href="#maintenance-support">
                              Maintenance and Support
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Comprehensive, fast and effective support.
                            </div>
                          </li>
                          <li>
                            <a className="fw-bold" href="#">
                              Professional Services
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Consult with the experts to create your best
                              customer journey.
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <a href="#">Professional Services</a>
                        <ul>
                          <li>
                            <a className="fw-bold" href="#">
                              Microsoft Team Setup & Configuration
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Advanced call recording and analytics solution
                              designed for capturing voice and video
                              communications in real-time.
                            </div>
                          </li>
                          <li>
                            <a className="fw-bold" href="#">
                              Zoom Setup & Configuration
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              AI solution that powers intelligent and automated
                              customer interactions using voice and chat.
                            </div>
                          </li>
                          <li>
                            <a className="fw-bold" href="#">
                              Hosted Enterprise Session Border Controller
                            </a>
                            <div
                              style={{ padding: "0px 25px", fontSize: "14px" }}
                            >
                              Post-meeting analytics and reporting solution
                              designed to optimize the meeting experience.
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="#maintenance-support">Maintenance and Support</a>
                      </li>
                      <li>
                        <Link to={"/technical-center"}>Technical Center</Link>
                      </li>
                    </ul>
                  </li>
                  {/* <li
                    className={`${
                      selection.selection == 'technical' ? 'current' : ''
                    }`}
                  >
                    <Link to={'/technical-center'}>Technical Center</Link>
                  </li> */}
                </ul>
              </nav>
              {/* <!-- Main Menu End--> */}
            </div>

            <div className="outer-box">
              {/* <!-- Mobile Nav toggler --> */}
              <div className="mobile-nav-toggler">
                <span className="icon lnr-icon-bars"></span>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Header Lower --> */}

        {/* <!-- Mobile Menu  --> */}
        <div className="mobile-menu">
          <div className="menu-backdrop"></div>

          {/* <!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header--> */}
          <nav className="menu-box">
            <div className="upper-box">
              <div className="nav-logo">
                <Link to={"/"}>
                  <img
                    src="/images/startech_logo.png"
                    alt="Star Tech Logo"
                    title=""
                  />
                </Link>
              </div>
              <div className="close-btn">
                <i className="icon fa fa-times"></i>
              </div>
            </div>

            <ul className="navigation clearfix">
              {/* <!--Keep This Empty / Menu will come through Javascript--> */}
            </ul>
            <ul className="contact-list-one">
              <li>
                {/* <!-- Contact Info Box --> */}
                <div className="contact-info-box">
                  <i className="icon lnr-icon-phone-handset"></i>
                  <span className="title">Call Now</span>
                  <a href="tel:+60377828826"> +603-7782 8826 </a>
                  <br />
                  <a
                    href={`https://api.whatsapp.com/send/?phone=60126232077`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    +6012-6232077{" "}
                  </a>
                </div>
              </li>
              <li>
                {/* <!-- Contact Info Box --> */}
                <div className="contact-info-box">
                  <span className="icon lnr-icon-envelope1"></span>
                  <span className="title">Send Email</span>
                  <a href="mailto:enquiry@startechdistribution.com">
                    enquiry@startechdistribution.com
                  </a>
                </div>
              </li>
            </ul>

            <ul className="social-links">
              <li>
                <a
                  href="https://www.linkedin.com/company/startechdistribution"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/startechdistributionsb/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        {/* <!-- End Mobile Menu --> */}

        {/* <!-- Sticky Header  --> */}
        <div className="sticky-header">
          {/* <!-- Header Top --> */}
          <div className="header-top">
            <div className="inner-container">
              <div className="top-left">
                {/* <!-- Info List --> */}
                <ul className="list-style-one">
                  <li>
                    <i className="fa fa-envelope"></i>
                    <a href="mailto:enquiry@startechdistribution.com">
                      enquiry@startechdistribution.com
                    </a>
                  </li>
                  <li>
                    <i className="fa fa-map-marker-alt"></i> No.31-2, Petaling
                    Utama Avenue, Jalan PJS 1/50, Taman Petaling Utama, 46150
                    Petaling Jaya, Selangor, Malaysia.
                  </li>
                </ul>
              </div>

              <div className="top-right">
                <ul className="useful-links">
                  <li>
                    <Link to={"/career"}>
                      <u>Career</u>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/contact"}>
                      <u>Contact Us</u>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/cart"}>
                      <u>Enquiry List</u>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="outer-box">
              <ul className="social-icon-one">
                <li>
                  <a
                    href="https://www.linkedin.com/company/startechdistribution"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="fab fa-linkedin"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/startechdistributionsb/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="fab fa-facebook-square"></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* <!-- Header Top --> */}
          <div className="auto-container">
            <div className="inner-container">
              {/* <!--Logo--> */}
              <div className="logo">
                <Link to={"/"} title="">
                  <img
                    src="/images/startech_logo.png"
                    alt="Star Tech Logo"
                    title=""
                  />
                </Link>
              </div>

              {/* <!--Right Col--> */}
              <div className="nav-outer">
                {/* <!-- Main Menu --> */}
                <nav className="main-menu">
                  <div className="navbar-collapse show collapse clearfix">
                    <ul className="navigation clearfix  d-flex align-items-center">
                      {/* <!--Keep This Empty / Menu will come through Javascript--> */}
                    </ul>
                  </div>
                </nav>
                {/* <!-- Main Menu End--> */}

                {/* <!--Mobile Navigation Toggler--> */}
                <div className="mobile-nav-toggler">
                  <span className="icon lnr-icon-bars"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Sticky Menu --> */}
      </header>
      {/* <!--End Main Header --> */}
    </>
  );
};

export default Header;
